import { useSelector } from 'react-redux';
import { getKey, getTab } from '../../../shared/utils/tabsUtils';
import { usePermission } from '../../../shared/hooks/usePermission';
import UsefulToolsWidget from '../../../shared/components/pages/usefulToolsPage/usefulToolsWidget/UsefulToolsWidget';
import MessagesWidget from './messagesWidget/MessagesWidget';
import Footer from '../../../shared/layout/footer/Footer';
import SchoolLogoWidget from '../../../shared/components/widget/schoolLogoWidget/SchoolLogoWidget';
import SchoolImageWidget from '../../../shared/components/widget/schoolImageWidget/SchoolImageWidget';
import DefaultLogoWidget from '../../../shared/components/widget/defaultLogoWidget/DefaultLogoWidget';
import BgtCountersWidget from '../../pages/bgtPage/bgtCountersWidget/BgtCountersWidget';
import RealisticIsraelWidget from '../../../shared/components/pages/realisticIsrael/realisticIsraelWidget/RealisticIsraelWidget';
import MyLearningWidget from '../myLearningPage/myLearningWidget/MyLearningWidget';
import CalendarWidget from '../calanderPage/calendarWidget/CalendarWidget';
import AssignPopupHeader from '../myLearningPage/assignStudyGroup/assignPopupHeader/AssignPopupHeader';
import ShowOncePerUser from '../../../shared/components/ui/showOncePerUser/ShowOncePerUser ';
import DiscoveryWidget from '../discoveryPage/discoveryWidget/DiscoveryWidget';
import ProfessionalDevelopmentWidget from '../ProfessionalDevelopmentPage/ProfessionalDevelopmentWidget/ProfessionalDevelopmentWidget';
import PersonalAssistantBotWidget from '../personalAssistantBotPage/PersonalAssistantBotWidget/PersonalAssistantBotWidget';
import GoogleMeetWidgetTeacher from './googleMeetWidgetTeacher/GoogleMeetWidgetTeacher';
import FinancialEducationWidget from './financialEducationWidget/FinancialEducationWidget';
import ShortcutWidget from './ShortcutWidget/ShortcutWidget';
import AssignWidget from '../myLearningPage/assignWidget/AssignWidget';
import ManagementWidget from '../../../shared/components/pages/managementPage/managementWidget/ManagementWidget';
import CrbWidget from '../../../shared/components/widget/crbWidget/CrbWidget';
import HtcWidget from '../../../shared/components/widget/htcWidget/HtcWidget';
import WidgetPair from '../../../shared/components/features/widget/widgetPair/WidgetPair';
import SchedualMiniWidget from '../../features/SchedualMiniWidget/SchedualMiniWidget';
import CreateStudyGroupMiniWidget from '../../features/createStudyGroupMiniWidget/CreateStudyGroupMiniWidget';
import RegularAppletsWidget from '../../features/appletsWidget/regularAppletsWidget/RegularAppletsWidget';
import MobileAppletsWidget from '../../features/appletsWidget/mobileAppletsWidget/MobileAppletsWidget';
import { deviceTypes } from '../../../shared/enums/deviceTypes';
import classes from './Home.module.css';

const Home = () => {

    const { userDetails } = useSelector(state => state.auth);
    const deviceType = useSelector(state => state.responsive.deviceType);
    const hasPermission = usePermission();
    const canSeeBgt = hasPermission(getKey("bgt"));
    const canSeeCrb = hasPermission(getKey("crbDashboard"));
    const canSeeHtc = hasPermission(getKey("htcDashboard"));
    const canSeeRealistic = hasPermission(getTab("realisticIsrael")?.visibleTo);
    const canSeeGoogleMeet = hasPermission(getTab("googleMeet")?.visibleTo);
    const canSeeManagement = hasPermission(getTab("managerDashboard")?.visibleTo);
    const canSeeBots = hasPermission(getTab("bots")?.visibleTo);
    const canSeeFinancialEducation = hasPermission(getTab("financialEducation")?.visibleTo);

    return (
        <div className={`${classes.Home} HomePage`}>
            <ShowOncePerUser localStoregKey="assignHeader">
                <AssignPopupHeader Btn={true} />
            </ShowOncePerUser>
            <div className={classes.Content}>
                <div className={classes.TopPart}>
                    <MessagesWidget />
                    <WidgetPair className={classes.MyLearningWidgetPair}>
                        <MyLearningWidget />
                        <CreateStudyGroupMiniWidget className={classes.MyLearningMiniWidget} />
                    </WidgetPair>
                    <div className={classes.WidgetsColumn}>
                        {canSeeBgt ?
                            <BgtCountersWidget />
                            :
                            canSeeRealistic ?
                            <RealisticIsraelWidget />
                            :
                            <DefaultLogoWidget />
                        }
                        <UsefulToolsWidget />
                    </div>
                    <WidgetPair className={classes.CalendarWidgetPair}>
                        <CalendarWidget />
                        <SchedualMiniWidget className={classes.CalendarMiniWidget} />
                    </WidgetPair>
                </div>
                <div className={classes.BottomPart}>
                    <div className={classes.ClassroomAppletRow}>
                        {deviceType === deviceTypes.mobile ?
                            <MobileAppletsWidget />
                            :
                            <RegularAppletsWidget />
                        }
                    </div>
                    {userDetails?.defaultSchool?.imageUrl && <SchoolImageWidget />}
                    {canSeeManagement && <ManagementWidget />}
                    {canSeeBgt && canSeeRealistic && <RealisticIsraelWidget />}
                    {canSeeBots && <PersonalAssistantBotWidget />}
                    <ProfessionalDevelopmentWidget />
                    <AssignWidget />
                    {canSeeHtc && <HtcWidget />}
                    {canSeeCrb && <CrbWidget />}
                    <DiscoveryWidget />
                    {canSeeGoogleMeet && <GoogleMeetWidgetTeacher />}
                    <ShortcutWidget key={userDetails?.defaultSchool?.id} />
                    {userDetails?.defaultSchool?.iconUrl && <SchoolLogoWidget />}
                    {canSeeFinancialEducation && <FinancialEducationWidget />}
                </div>
            </div>
            <Footer />
        </div>
    )
}
export default Home;
